import type { CSSProperties } from 'react';
import cx from 'classnames';
import { SelectStatus } from '@types';
import ImgNone from './none.png';
import ImgAll from './all.png';
import ImgPart from './part.png';
import Icon from '../Icon';

interface Props {
  status?: SelectStatus;
  checked?: boolean;
  className?: string;
  label?: string;
  style?: CSSProperties;
}

function Checkbox({
  status = SelectStatus.none,
  checked,
  className,
  label,
  style,
}: Props) {
  const renderStatus = () => {
    if (checked !== undefined) {
      return checked ? <Icon src={ImgAll} /> : <Icon src={ImgNone} />;
    }
    if (status === SelectStatus.all) return <Icon src={ImgAll} />;
    if (status === SelectStatus.part) return <Icon src={ImgPart} />;
    return <Icon src={ImgNone} />;
  };

  return (
    <div
      className={cx(
        className,
        'inline-flex max-w-full shrink-0 cursor-pointer select-none items-center'
      )}
      style={style}
    >
      {renderStatus()}
      {!!label && <div className="ml-10 truncate">{label}</div>}
    </div>
  );
}

export default Checkbox;
